import { useMutation, useQueryClient } from 'react-query';

import { createSite } from 'api/clients/createSite';

const useCreateSite = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: createSiteSwitch,
    isLoading,
  } = useMutation(createSite, {
    onSuccess: () => {
      queryClient.invalidateQueries('siteCreation');
    },
  });

  return {
    isSuccess,
    createSite: createSiteSwitch,
    isLoading,
  };
};

export default useCreateSite;
